module.exports = __webpack_public_path__ + "static/media/ben_lynch.38e9c0b2.png";